import { Outlet, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import { Navbar } from "../components/header/Navbar"; 
import UserNavbar from "../components/header/UserNavbar"; 
import { Footer } from "../components/footer/Footer";

export function PublicLayout() {
  const [isUserLoggedIn, setIsUserLoggedIn] = useState(false);
  const [profile, setProfile] = useState<any>(null);
  
  // 🟢 1. Hook into the current URL
  const location = useLocation(); 

  useEffect(() => {
    const userCode = localStorage.getItem('user_code');
    
    if (userCode) {
      setIsUserLoggedIn(true);
      setProfile({
        name: localStorage.getItem('user_name') || 'User',
        userCode: userCode
      });
    } else {
      // 🟢 2. CRITICAL: If no code is found, reset the state to show Public Navbar
      setIsUserLoggedIn(false);
      setProfile(null);
    }
  // 🟢 3. Re-run this check every time the URL changes (e.g., when logging out!)
  }, [location.pathname]); 

  return (
    <div className="min-h-screen bg-gradient-to-b from-blue-50/30 to-white flex flex-col">
      
      {isUserLoggedIn ? (
        <UserNavbar profile={profile} />
      ) : (
        <Navbar />
      )}
      
      <main className="flex-grow">
        <Outlet />
      </main>
      
      <Footer />
    </div>
  );
}